module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpipa.68bd4784f79ee2b4cbb8e8b990de6854.png";